import { Box, Button, styled } from '@ltvco/refresh-lib/theme';

export const ViewToggleContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const ViewLabel = styled('span')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.primary,
}));

export const ToggleButtonGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export interface ToggleButtonProps {
  isActive?: boolean;
  buttonPosition: 'left' | 'right';
}

export const ToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'buttonPosition',
})<ToggleButtonProps>(({ theme, isActive, buttonPosition }) => ({
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '40px',
  padding: 0,
  paddingLeft: buttonPosition === 'left' ? '16px' : '12px',
  paddingRight: buttonPosition === 'right' ? '16px' : '12px',
  backgroundColor: isActive
    ? theme.palette.primary.main
    : theme.palette.common.white,
  border: `1px solid ${
    isActive ? theme.palette.primary.main : theme.palette.text.disabled
  }`,
  borderRadius: buttonPosition === 'left' ? '20px 0 0 20px' : '0 20px 20px 0',
  boxShadow: 'none',
  textTransform: 'none',
  transition: 'all 0.2s ease-in-out',
  '& svg': {
    fontSize: '20px',
    color: isActive ? theme.palette.common.white : theme.palette.text.secondary,
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: isActive
      ? theme.palette.primary.dark
      : theme.palette.grey[50],
    boxShadow: 'none',
  },
}));
